import {
  Component,
  HostListener,
  OnInit,
  ChangeDetectionStrategy,
} from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Title } from '@angular/platform-browser';
import { NavigationEnd, Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { LoginService } from './login/login.service';
import {
  IcteamPrankComponent,
  PrankInterface,
} from './prank/icteam-prank/icteam-prank.component';
import { FcmRegistrationService } from './notifications/fcm-registration.service';
declare let gtag: Function;
declare let fbq: Function;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class AppComponent implements OnInit {
  dialogRef: MatDialogRef<IcteamPrankComponent>;
  favIcon: HTMLLinkElement = document.querySelector('#appFavicon');
  constructor(
    private titleService: Title,
    private router: Router,
    private dialog: MatDialog,
    private loginService: LoginService,
    private fcmRegistration: FcmRegistrationService,
  ) {
    // this.titleService.setTitle(environment.org);
    if (this.favIcon) {
      this.favIcon.href = environment.assets.favIcon;
    }
    router.events.subscribe((y: NavigationEnd) => {
      if (y instanceof NavigationEnd) {
        // gtag('config', 'UA-{ID}', { 'page_path': y.url });
        fbq('track', 'PageView');
      }
    });
  }

  async ngOnInit(): Promise<void> {
    this.loginService.renewCookieExpiry();
    await this.fcmRegistration.registerBrowserToken();
  }

  // Also reset the cookie expiry when a backgrounded tab is brought back to the
  // foreground, which doesn't re-trigger ngOnInit.
  @HostListener('document:visibilitychange')
  onVisibilityChange(): void {
    if (document.visibilityState === 'visible') {
      this.loginService.renewCookieExpiry();
    }
  }
}
